import { create } from 'zustand';
import type { Order, Product } from '@/types';

interface QuantityPickerState {
  product: Product | null;
  openQuantityPicker: (product: Product) => void;
  closeQuantityPicker: () => void;
}

interface LightboxState {
  imageUrl: string | null;
  alt: string;
  openLightbox: (url: string, alt?: string) => void;
  closeLightbox: () => void;
}

interface OrderDetailState {
  order: Order | null;
  openOrderDetail: (order: Order) => void;
  closeOrderDetail: () => void;
}

interface OrderSuccessState {
  orderId: string | null;
  showOrderSuccess: (orderId: string) => void;
  closeOrderSuccess: () => void;
}

export const useQuantityPickerStore = create<QuantityPickerState>((set) => ({
  product: null,
  openQuantityPicker: (product) => set({ product }),
  closeQuantityPicker: () => set({ product: null }),
}));

export const useLightboxStore = create<LightboxState>((set) => ({
  imageUrl: null,
  alt: '',
  openLightbox: (url, alt = '') => set({ imageUrl: url, alt }),
  closeLightbox: () => set({ imageUrl: null, alt: '' }),
}));

export const useOrderDetailStore = create<OrderDetailState>((set) => ({
  order: null,
  openOrderDetail: (order) => set({ order }),
  closeOrderDetail: () => set({ order: null }),
}));

export const useOrderSuccessStore = create<OrderSuccessState>((set) => ({
  orderId: null,
  showOrderSuccess: (orderId) => set({ orderId }),
  closeOrderSuccess: () => set({ orderId: null }),
}));
